"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegExpCheckInteger = RegExpCheckInteger;
const RegExpInteger = /^([+-]?[1-9]\d*|0)$/;
function RegExpCheckInteger(integerToCheck) {
    if (integerToCheck) {
        return RegExpInteger.test(integerToCheck);
    }
    else {
        return false;
    }
}
